import { configureStore } from '@reduxjs/toolkit'
// import apiReducer from './common'
import cardReducer from './cartSlice'


 const store = configureStore({
  reducer: {cardReducer}
})

export default store